import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';
import { useLocation } from 'react-router';

import { MainNavigation } from '@/app/shell/MainNavigation';

const MobileFooterContainerContext = createContext<HTMLDivElement | null>(null);

export function useMobileFooterContainer(): HTMLDivElement | null {
  return useContext(MobileFooterContainerContext);
}

function useFocusH1OnNavigate() {
  const location = useLocation();

  useEffect(() => {
    document.querySelector<HTMLElement>('h1')?.focus();
  }, [location.pathname]);
}

export function NavLayout({ children }: { children: ReactNode }) {
  useFocusH1OnNavigate();
  const [mobileFooterContainer, setMobileFooterContainer] = useState<HTMLDivElement | null>(null);

  return (
    <div className="nav-layout">
      <div className="nav-layout__nav-menu">
        <MainNavigation />
      </div>
      <div className="nav-layout__content">
        <MobileFooterContainerContext.Provider value={mobileFooterContainer}>
          {children}
        </MobileFooterContainerContext.Provider>
      </div>
      <div className="nav-layout__mobile-footer" ref={setMobileFooterContainer} />
    </div>
  );
}
